import halkaBox from 'halkabox';

let getGliderTries = 0;
const getGliderTriesMax = 10;
const getGliderTriesInterval = 100;

class HeaderGallery {
    sliderSelectors = {
        frame: '.header-gallery__slider',
        slide: '.header-gallery__image',
        count: '.header-gallery__count',
        countCurrent: '.header-gallery__count-current',
        countTotal: '.header-gallery__count-total',
    }

    sliderOptions = {
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        rewind: true,
        resizeLock: true,
        scrollLock: true,
    }

    constructor(galleryEl) {
        this.galleryEl = galleryEl;
        this._sliderFrame = this.galleryEl.querySelector(this.sliderSelectors.frame);
        this._slider = null;
        this._sliderSlides = this._sliderFrame.querySelectorAll(this.sliderSelectors.slide);
        this._slidesCount = this._sliderSlides.length;
        this._sliderCountEl = this.galleryEl.querySelector(this.sliderSelectors.count);
        this._sliderCountCurrentEl = this._sliderCountEl.querySelector(this.sliderSelectors.countCurrent);
        this._sliderCountTotalEl = this._sliderCountEl.querySelector(this.sliderSelectors.countTotal);
        this._modal = null;

        // Listen to breakpoint change to prevent incorrect current count
        this._mql = window.matchMedia('(max-width: 959px)');
        this._mql.addEventListener('change', this._updateSliderCount)

        // Update count when new slide is visible
        this.galleryEl.addEventListener('glider-slide-visible', this._updateSliderCount.bind(this));

        this._initSlider()
        this._initSliderCountTotal();
        this._initMediaWall();
    }

    /**
     * Get the index of the current active slide inside the slider
     * @returns {number}
     */
    get activeSlideIndex() {
        return +this._sliderFrame.querySelector('.glider-slide.visible').getAttribute('data-gslide') + 1;
    }

    /**
     * Create a slider instance
     * @private
     */
    _initSlider() {
        this._slider = new Glider(this._sliderFrame, this.sliderOptions);
    }

    /**
     * Initialize the slider count with the correct total slides value
     * @private
     */
    _initSliderCountTotal() {
        if (!this._sliderCountTotalEl) return;
        this._sliderCountTotalEl.textContent = String(this._slidesCount);
    }

    /**
     * Update the value of the current count
     * @private
     */
    _updateSliderCount() {
        if (!this._sliderCountCurrentEl) return;
        this._sliderCountCurrentEl.textContent = this.activeSlideIndex;
    }

    /**
     * Initialize the lightbox listeners on the media wall
     * @private
     */
    _initMediaWall() {
        this.galleryEl.querySelectorAll('[target="media-wall"]').forEach((element) => {
            element.addEventListener('click', (event) => {
                if (event.metaKey || event.ctrlKey) {
                    return;
                }

                const href = element.getAttribute('href');
                const src = (href.indexOf('?') !== -1 ? href.split('?')[0] + '?' + 'toujou-ajax-modal=1' + '&' + href.split('?')[1] : (href.indexOf('#') !== -1 ? href.split('#')[0] + '?' + 'toujou-ajax-modal=1' + '#' + href.split('#')[1] : href + '?' + 'toujou-ajax-modal=1'));
                this._openMediaWall(src);

                event.preventDefault();
                event.stopPropagation();
            });
        });
    }

    /**
     * Create, populate and show media wall modal.
     * Scroll target image into view
     *
     * @param url
     * @returns {Promise<void>}
     * @private
     */
    async _openMediaWall(url) {
        try {
            if (!this._modal) {
                const response = await fetch(url);

                const dummyElement = document.createElement('div');
                dummyElement.innerHTML = await response.text();

                const mediaWall = dummyElement.querySelector('.media-wall');
                const modalId = 'media-wall-modal';
                this._modal = document.createElement('DIALOG');

                this._modal.id = modalId;
                this._modal.appendChild(mediaWall);
                document.body.appendChild(this._modal);

                const closeButton = this._modal.querySelector('[dialog-dismiss]');
                if (closeButton) {
                    closeButton.addEventListener('click', () => {
                        this._modal.close();
                    });
                }

                this._modal.addEventListener('keydown', function(event) {
                    if (event.key === 'Escape') {
                        this._modal.close();
                    }
                });

                this._modal.addEventListener('close', (event) => {
                    document.body.removeAttribute('media-wall-opened');
                });

                const potentialLightBoxElements = this._modal.querySelectorAll(".media-wall");
                if (potentialLightBoxElements) {
                    potentialLightBoxElements.forEach((el) => {
                        const lightboxID = el.dataset.lightbox || el.dataset.gallery;
                        lightboxID && halkaBox.run(lightboxID);
                    });
                }
            }

            requestAnimationFrame(() => {
                this._modal.show();

                document.body.setAttribute('media-wall-opened', '');

                const hash = url.split('#')[1] ?? null;
                if (hash) {
                    // window.location.hash = hash;

                    const targetElement = document.querySelector(`#${hash} .media-wall__image`);
                    if (!targetElement) return;

                    requestAnimationFrame(() => {
                        targetElement.scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        })
                    });
                }
            });
        } catch(e) {
            console.error('SEABREEZE: there was an error while loading the media-wall: ', e);
        }
    }
}

/**
 * Wait for the global Glider object to be available and then initialize the Header Gallery
 */
function initCustomTripPageJS() {
    const headerGalleryEl = document.querySelector('.header-gallery');
    const glider = window.Glider;

    if (!glider) {
        setTimeout(() => {
            if (getGliderTries < getGliderTriesMax) {
                getGliderTries++;
                return initCustomTripPageJS();
            } else {
                console.error('SEABREEZE: Could not initialize the header gallery element because "Glider" was not found!');
                return;
            }
        }, getGliderTriesInterval);
    } else {
        if (!headerGalleryEl) {
            return;
        }

        new HeaderGallery(headerGalleryEl)
    }
}

if (document.readyState === "complete" || document.readyState === "interactive") {
    setTimeout(initCustomTripPageJS);
} else {
    document.addEventListener("DOMContentLoaded", initCustomTripPageJS);
}
